module.exports = __webpack_public_path__ + "static/auto_import_737x562-ae825c2287add8fd91b9a68cd0936854.webp";